/*
 * General custom scripts
 */
import { MegaMenu } from './front/megamenu';

window.addEventListener( 'DOMContentLoaded', () => {

	new MegaMenu();

} );